import { FC, useCallback, useEffect } from 'react';
import { useAppDispatch } from '../services/store';
import { api } from '../services/api';

export const AuthProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useAppDispatch();
  const relogin = useCallback(() => dispatch(api.endpoints.relogin.initiate()), [dispatch]);

  useEffect(() => {
    relogin().refetch();
  }, [relogin]);

  return <>{children}</>;
};
